import $ from "/js/libs/jquery-3.3.1.min.js";

window.constrain = function (aNumber, aMin, aMax) {
  return aNumber > aMax ? aMax : aNumber < aMin ? aMin : aNumber;
};

window.map = function (value, istart, istop, ostart, ostop) {
  return ostart + (ostop - ostart) * ((value - istart) / (istop - istart));
};

window.randomInRange = function (map, prop) {
  var min = map[prop + "Min"],
    max = map[prop + "Max"];
  return min + (max - min) * Math.random();
}

window.getRandomInt = function (min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

window.getRandomFloat = function (min, max) {
  return Math.random() * (max - min + 1) + min;
}

window.getURLParameter = function (name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [, ""])[1].replace(/\+/g, '%20')) || null;
};

window.millis = function () {
  return Date.now();
}

window.dist = function (x1, y1, x2, y2) {
  return Math.sqrt(Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2));
}

window.shuffle = function (array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

window.validateEmail = function (email) {
  // It will only ensure that the address fits within the most basic requirements you mentioned:
  // a character before the @ and something before and after the dot in the domain part.
  // Validating more than that will probably be wrong (you always have the chance of blacklisting a valid email).
  var emailRegExp = /^.+@.+\..+$/;
  var valid = emailRegExp.test(email);
  // console.log("Email validation", email, valid);
  return valid;
}


window.getDate = function (language) {

  var objToday = new Date();
  var weekday, dayOfWeek, domEnder, dayOfMonth, months, curMonth, curYear, curHour, curMinute, curSeconds,
    curMeridiem, dayOfMonthNoEnd;

  if (language == "fr") {
    objToday = new Date();
    weekday = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
    months = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juilet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
  } else {
    objToday = new Date();
    weekday = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
    months = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
  }

  domEnder = new Array('th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th');
  dayOfWeek = weekday[objToday.getDay()];
  dayOfMonthNoEnd = objToday.getDate();
  dayOfMonth = (objToday.getDate() < 10) ? '0' + objToday.getDate() + domEnder[objToday.getDate()] : objToday.getDate() + domEnder[parseFloat(("" + objToday.getDate()).substr(("" + objToday.getDate()).length - 1))];
  curMonth = months[objToday.getMonth()];
  curYear = objToday.getFullYear();
  curHour = objToday.getHours() > 12 ? objToday.getHours() - 12 : (objToday.getHours() < 10 ? "0" + objToday.getHours() : objToday.getHours());
  curMinute = objToday.getMinutes() < 10 ? "0" + objToday.getMinutes() : objToday.getMinutes();
  curSeconds = objToday.getSeconds() < 10 ? "0" + objToday.getSeconds() : objToday.getSeconds();
  curMeridiem = objToday.getHours() > 12 ? "PM" : "AM";

  if (language == "fr") {
    //return (dayOfWeek + " " + dayOfMonthNoEnd + " " + curMonth + " " + curYear);
    return (dayOfWeek + " " + dayOfMonthNoEnd + " " + curMonth);
  } else if (language == "hour") {
    return (curHour + ":" + curMinute + " " + curMeridiem);
  } else {
    //return (dayOfWeek + " " + curMonth + " " + dayOfMonth + " " + curYear);
    return (dayOfWeek + " " + curMonth + " " + dayOfMonth);
  }
};

/*!
 * Behaves the same as setInterval except uses requestAnimationFrame() where possible for better performance
 * modified gist.github.com/joelambert/1002116
 * the fallback function requestAnimFrame is incorporated
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/sxrzktkz/
 * @param {Object} fn The callback function
 * @param {Int} delay The delay in milliseconds
 * requestInterval(fn, delay);
 */
window.requestInterval = function (fn, delay) {
  var requestAnimFrame = (function () {
      return window.requestAnimationFrame || function (callback, element) {
        window.setTimeout(callback, 1000 / 60);
      };
    })(),
    start = new Date().getTime(),
    handle = {};

  function loop() {
    handle.value = requestAnimFrame(loop);
    var current = new Date().getTime(),
      delta = current - start;
    if (delta >= delay) {
      fn.call();
      start = new Date().getTime();
    }
  }

  handle.value = requestAnimFrame(loop);
  return handle;
};
/*!
 * Behaves the same as clearInterval except uses cancelRequestAnimationFrame()
 * where possible for better performance
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/sxrzktkz/
 * @param {Int|Object} handle function handle, or function
 * clearRequestInterval(handle);
 */
window.clearRequestInterval = function (handle) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(handle.value);
  } else {
    window.clearInterval(handle);
  }
};
/*!
 * Behaves the same as setTimeout except uses requestAnimationFrame()
 * where possible for better performance
 * modified gist.github.com/joelambert/1002116
 * the fallback function requestAnimFrame is incorporated
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/dnyomc4j/
 * @param {Object} fn The callback function
 * @param {Int} delay The delay in milliseconds
 * requestTimeout(fn,delay);
 */
window.requestTimeout = function (fn, delay) {
  var requestAnimFrame = (function () {
      return window.requestAnimationFrame || function (callback, element) {
        window.setTimeout(callback, 1000 / 60);
      };
    })(),
    start = new Date().getTime(),
    handle = {};

  function loop() {
    var current = new Date().getTime(),
      delta = current - start;
    if (delta >= delay) {
      fn.call();
    } else {
      handle.value = requestAnimFrame(loop);
    }
  }

  handle.value = requestAnimFrame(loop);
  return handle;
};
/*!
 * Behaves the same as clearTimeout except uses cancelRequestAnimationFrame()
 * where possible for better performance
 * gist.github.com/joelambert/1002116
 * gist.github.com/englishextra/873c8f78bfda7cafc905f48a963df07b
 * jsfiddle.net/englishextra/dnyomc4j/
 * @param {Int|Object} handle The callback function
 * clearRequestTimeout(handle);
 */
window.clearRequestTimeout = function (handle) {
  if (window.cancelAnimationFrame) {
    window.cancelAnimationFrame(handle.value);
  } else {
    window.clearTimeout(handle);
  }

};

// https://stackoverflow.com/questions/7424155/javascript-how-to-get-setinterval-to-start-now
window.setIntervalAndExecute = function (fn, t) {
  fn();
  return (setInterval(fn, t));
}

// Enables prototype inheritence using this simple command
// https://stackoverflow.com/questions/4152931/javascript-inheritance-call-super-constructor-or-use-prototype-chain
window.extend = function (base, sub) {
  // Avoid instantiating the base class just to setup inheritance
  // Also, do a recursive merge of two prototypes, so we don't overwrite
  // the existing prototype, but still maintain the inheritance chain
  // Thanks to @ccnokes
  var origProto = sub.prototype;
  sub.prototype = Object.create(base.prototype);
  for (var key in origProto) {
    sub.prototype[key] = origProto[key];
  }
  // The constructor property was set wrong, let's fix it
  Object.defineProperty(sub.prototype, 'constructor', {
    enumerable: false,
    value: sub
  });
}

window.guid = function () {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }

  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

window.getTranslate = function (item) {
  var transArr = [];

  if (!window.getComputedStyle) return;
  var style = getComputedStyle(item),
    transform = style.transform || style.webkitTransform || style.mozTransform || style.msTransform;
  var mat = transform.match(/^matrix3d\((.+)\)$/);
  if (mat) return parseFloat(mat[1].split(', ')[13]);

  mat = transform.match(/^matrix\((.+)\)$/);
  mat ? transArr.push(parseFloat(mat[1].split(', ')[4])) : transArr.push(0);
  mat ? transArr.push(parseFloat(mat[1].split(', ')[5])) : transArr.push(0);

  return transArr;
}

window.inElectron = function () {
  return typeof process != "undefined" && process.versions.hasOwnProperty('electron')
}

window.inBrightSign = function () {
  return  (typeof BSControlPort != "undefined");
}

window.numberPad = function (num, size) {
  var s = Math.abs(num) + "";
  var isPositive = (Math.abs(num) / num != -1) || (num == 0);
  while (s.length < size) s = "0" + s;
  return (isPositive ? " " : "-") + s;
}

window.transEndEventNames = {
  'WebkitTransition': 'webkitTransitionEnd',
  'MozTransition': 'transitionend',
  'OTransition': 'oTransitionEnd otransitionend',
  'msTransition': 'MSTransitionEnd',
  'transition': 'transitionend'
};
window.transitionEnd = window.transEndEventNames[Modernizr.prefixed('transition')];

window.animEndEventNames = {
  'WebkitAnimation': 'webkitAnimationEnd',
  'MozAnimation': 'Animationend',
  'OAnimation': 'oAnimationEnd oAnimationend',
  'msAnimation': 'MSAnimationEnd',
  'animation': 'animationend'
};
window.animationEnd = window.animEndEventNames[Modernizr.prefixed('animation')];

// Convert <img> SVG to inline
;(function () {

  // Prevent reloading a file already loaded
  let svgCache = {};

  window.convertSVGToInline = function (callback) {
    let promises = [];

    $('img.svg').each(function () {
      var $img = $(this);
      var imgID = $img.attr('id');
      var imgClass = $img.attr('class');
      var imgURL = $img.attr('src');

      promises.push(new Promise(function (resolve, reject) {
        if (svgCache[imgURL] === undefined) {
          $.ajax({
            url: imgURL,
            success: $.proxy(function ($img, imgID, imgClass, data) {
              // Get the SVG tag, ignore the rest
              var $svg = $("<div>" + data + "</div>").find('svg');
              // Add replaced image's ID to the new SVG
              if (typeof imgID !== 'undefined') {
                $svg = $svg.attr('id', imgID);
              }
              // Add replaced image's classes to the new SVG
              if (typeof imgClass !== 'undefined') {
                $svg = $svg.attr('class', imgClass + ' replaced-svg');
              }
              // Remove any invalid XML tags as per http:validator.w3.org
              $svg = $svg.removeAttr('xmlns:a');

              // Replace all svg with the same URL
              $("img.svg[src='" + imgURL + "']").replaceWith($svg);

              // Add SVG to cache
              svgCache[imgURL] = $svg;

              // Resolve promise
              resolve();
            }, this, $img, imgID, imgClass),
            dataType: "text"
          });
        } else {
          // SVG already in cache, replace
          $("img.svg[src='" + imgURL + "']").replaceWith(svgCache[imgURL]);

          // Resolve promise
          resolve();
        }
      }));
    });

    // When all the promises are settled
    Promise.allSettled(promises).then(function (results) {
      if (callback !== undefined && typeof callback === "function") {
        callback();
      }
    });
  }
})();

// https://stackoverflow.com/a/22209579/1617768
// Adapted by Marc-Antoine Brodeur to search by property instead of data, and
// to add a param to be able to search with "contains" instead of "==" You can
// search for a key-value pair, you can additionally search for the presence of
// a prop, irrespective of its value.  Usage:  $('<b>').data('x',
// 1).filterByProperty('x', 1).length    // output: 1 $('<b>').data('x',
// 1).filterByProperty('x').length       // output: 1

;(function ($) {

  $.fn.filterByProperty = function (prop, val, contains) {
    var $self = this;
    var contains = typeof contains !== "undefined" ? contains : false;

    if (typeof val === 'undefined') {
      return $self.filter(
        function () {
          return typeof $(this).prop(prop) !== 'undefined';
        }
      );
    }
    return $self.filter(
      function () {
        if (contains) {
          var splittedProp = String($(this).prop(prop)).split(",");
          return $.inArray(String(val), splittedProp) !== -1;
        } else {
          return $(this).prop(prop) == val;
        }
      }
    );
  };

})($);
